import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import React from "react";

function SubscriptionDetailGenerico({
  userSubscriptions,
  setshowModalModify,
  isOperator,
}) {
  return (
    <>
      <div className="row no_print">
        <div className="col-lg-12 mt-3">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                {isOperator && (
                  <>
                    {(userSubscriptions?.state === "ADDED" ||
                      userSubscriptions?.state === "LOADED") && (
                      <div className="row align-items-center justify-content-center mb-4">
                        <button
                          type="button"
                          className="btn btn-primary text-success w-50 p-2 py-3"
                          onClick={() => {
                            setshowModalModify(true);
                          }}
                        >
                          <svg className="icon icon-white">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>{" "}
                          <span className="align-middle text-white">
                            Esito Valutazione
                          </span>
                        </button>
                      </div>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.descrizione && (
                            <div className="col-3">
                              Descrizione:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.descrizione}
                              </strong>
                            </div>
                          )}
                          <div className="col text-right">
                            <button
                              type="button"
                              className="btn btn-outline-primary text-success p-2"
                              onClick={() => {
                                setshowModalModify(true);
                              }}
                              title="Modifica iscrizione"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {!isOperator && (
                  <>
                    {userSubscriptions?.state === "ADDED" && (
                      <div className="alert alert-info mt-2">
                        La richiesta è in attesa di elaborazione.
                      </div>
                    )}
                    {userSubscriptions?.state === "LOADED" && (
                      <div className="alert alert-info mt-2">
                        In attesa di revisione da parte dell'ufficio di piano.
                      </div>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionDetailGenerico;
